import { fetchRequestWithTypes } from './index.js';

// PUT answer to a PX Question
// Based on Tech Doc: Managed Retirement | Account Opening Flow | Questions
// Endpoint: /apis/customers/v1/questions/{questionSlug}
export const PUT_PX_QUESTION_ANSWER_REQUEST = 'PUT_PX_QUESTION_ANSWER_REQUEST';
export const PUT_PX_QUESTION_ANSWER_SUCCESS = 'PUT_PX_QUESTION_ANSWER_SUCCESS';
export const PUT_PX_QUESTION_ANSWER_ERRORED = 'PUT_PX_QUESTION_ANSWER_ERRORED';

// GET answer to a PX Question
export const GET_PX_QUESTION_ANSWER_REQUEST = 'GET_PX_QUESTION_ANSWER_REQUEST';
export const GET_PX_QUESTION_ANSWER_SUCCESS = 'GET_PX_QUESTION_ANSWER_SUCCESS';
export const GET_PX_QUESTION_ANSWER_ERRORED = 'GET_PX_QUESTION_ANSWER_ERRORED';

// GET px-questions collection
export const GET_PX_QUESTION_COLLECTION_REQUEST = 'GET_PX_QUESTION_COLLECTION_REQUEST';
export const GET_PX_QUESTION_COLLECTION_SUCCESS = 'GET_PX_QUESTION_COLLECTION_SUCCESS';
export const GET_PX_QUESTION_COLLECTION_ERRORED = 'GET_PX_QUESTION_COLLECTION_ERRORED';

export const putPxQuestionAnswer = (body) => {
	const { questionSlug, answer } = body;

	return fetchRequestWithTypes({
		types: [
			PUT_PX_QUESTION_ANSWER_REQUEST,
			PUT_PX_QUESTION_ANSWER_SUCCESS,
			PUT_PX_QUESTION_ANSWER_ERRORED,
		],
		request: {
			method: 'PUT',
			path: `/apis/customers/v1/questions/${questionSlug}`,
			body: {
				answer,
			},
		},
		questionSlug,
	});
};

export const getPxQuestionAnswer = (questionSlug) => {
	return fetchRequestWithTypes({
		types: [
			GET_PX_QUESTION_ANSWER_REQUEST,
			GET_PX_QUESTION_ANSWER_SUCCESS,
			GET_PX_QUESTION_ANSWER_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/questions/${questionSlug}`,
		},
		questionSlug,
	});
};

export const getPxQuestionCollection = (collectionSlug) => {
	return fetchRequestWithTypes({
		types: [
			GET_PX_QUESTION_COLLECTION_REQUEST,
			GET_PX_QUESTION_COLLECTION_SUCCESS,
			GET_PX_QUESTION_COLLECTION_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/questions/collections/${collectionSlug}`,
		},
		collectionSlug,
	});
};
